import React, { useEffect, useState } from "react";
import CustomTable from "../../../../components/common/CustomTable";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import BodyHeader from "../../../../components/common/CommonBodyHeader";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomToggleSwitch from "../../../../components/common/CustomToggle";
import { listDriverMasterAsync } from "../../../../redux/features/driverMaster";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import { BsPencilSquare } from "react-icons/bs";
import { changeStatus } from "../../../../Api/dispatch/driver-dispatch";
import toast from "react-hot-toast";
import { driverMasterReportAsync } from "../../../../redux/features/reportSlice";
import { useBoolean } from "../../../../Hooks/useBoolean";
import * as XLSX from "xlsx";
import moment from "moment/moment";
import DownloadReportButton from "../../../../components/common/DownloadReportButton";
import { Box, Stack } from "@mui/material";
import DownloadSalaryReport from "./DownloadSalaryReport";

export default function DriverMasterList() {
   const navigate = useNavigate();
   const dispatch = useDispatch();

   const driverMaster = useSelector((state) => state.driverMaster);
   const driverMasterList = driverMaster?.dataList;
   const [isActiveLoading, setIsActiveLoading] = useState({
      id: "",
      status: false,
   });

   const [records, setRecords] = useState(driverMasterList);

   const reportPopup = useBoolean();

   useEffect(() => {
      setRecords(driverMasterList);
   }, [driverMasterList]);

   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      dispatch(
         listDriverMasterAsync({
            err: () => {
               dispatch(backdropLoadingAction(false));
            },
            done: () => {
               dispatch(backdropLoadingAction(false));
            },
         })
      );
   }, []);

   // Handle active inactive
   const handleActiveInactive = (driver) => {
      setIsActiveLoading({ id: driver?.id, status: true });
      changeStatus({ id: driver?.id, status: driver?.is_active === "1" ? "0" : "1" })
         .then((res) => {
            setIsActiveLoading({ id: driver?.id, status: false });
            dispatch(listDriverMasterAsync({}));
            toast.success(
               `Driver ${driver?.is_active === "1" ? "deactivated" : "activated"}`
            );
         })
         .catch((error) => {
            setIsActiveLoading({ id: driver?.id, status: false });
            toast.error(
               `Failed to ${driver?.is_active === "1" ? "deactivate" : "activate"} driver`
            );
         });
   };

   //  Download fleet Report
   const handleDownloadReport = (data) => {
      dispatch(backdropLoadingAction(true));

      dispatch(
         driverMasterReportAsync({
            data: data,
            err: () => {
               dispatch(backdropLoadingAction(false));
            },
            done: (report) => {
               const headers = [
                  "S. No.",
                  "Driver Name",
                  "Driver No.",
                  "Driver License No.",
                  "Driver License Expiry Date",
                  "Driver Aadhar No.",
                  "PAN Card",
                  "Driver DOB",
                  "Driver Joining Date",
                  "Driver Exit Date",
                  "Driver Address",
                  "Driver Salary",
                  "Eisaku Payroll / Contractor",
                  "Driver Account No.",
                  "Driver Account IFSC Code",
                  "Contractor commission amount",
                  "Driver Experience (Years)",
               ];

               const driverMasterDataArr = [];

               report?.forEach?.((item, index) => {
                  const arr = [];
                  arr.push(
                     index + 1, // S. No.
                     item?.name ?? "-", // Driver Name
                     item?.mobile ?? "-", // Driver No.
                     item?.driver_license ?? "-", // Driver License No.
                     item?.license_expiry_date ?? "-", // Driver License Expiry Date
                     item?.aadhar_card ?? "-", // Driver Aadhar No.
                     item?.pan_card ?? "-", // PAN Card
                     item?.dob ?? "-", // Driver DOB
                     item?.doj ?? "-", // Driver Joining Date
                     item?.doe ?? "-", // Driver Exit Date
                     item?.address ?? "-", // Driver Address
                     item?.driver_monthly_salary_amount ?? "-", // Driver Salary
                     item?.payroll ?? "-", // Eisaku Payroll / Contractor
                     item?.driver_account_number ?? "-", // Driver Account No.
                     item?.driver_ifsc_code ?? "-", // Driver Account IFSC Code
                     item?.monthly_salary_commission_amount ?? "-", // Contractor commission amount
                     item?.experience ?? "-" // Driver Experience (Years)
                  );
                  driverMasterDataArr.push(arr);
               });

               console.log({ driverMasterDataArr });

               // Combine headers and rows
               const sheetData = [headers, ...driverMasterDataArr];

               console.log({ report });
               const ws = XLSX.utils.aoa_to_sheet(sheetData);
               ws["!cols"] = new Array(report?.length)?.map(() => ({ width: 1500 }));
               const wb = XLSX.utils.book_new();
               XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
               XLSX.writeFile(wb, "DRIVER_MASTER_REPORT.xlsx");
               dispatch(backdropLoadingAction(false));
               reportPopup.onFalse();
            },
         })
      );
   };

   const columns = [
      {
         name: "Driver Name",
         selector: (row) => row.name,
         sortable: true,
      },
      {
         name: "Mobile No",
         selector: (row) => row.mobile || 9876543210,
      },
      {
         name: "License Number",
         selector: (row) => row.driver_license,
      },
      {
         name: "License Exp Date",
         selector: (row) => row.license_expiry_date,
      },
      {
         name: "Payroll Type",
         selector: (row) => row.payroll,
         sortable: true,
      },
      {
         name: "Action",
         width: "9rem",
         selector: (row) => {
            return (
               <div className="d-flex align-items-center">
                  <button
                     className="btn"
                     onClick={() => navigate(`/driver-master/edit/${row?.id}`)}
                  >
                     <BsPencilSquare
                        className="text-primary"
                        style={{ height: "1.5rem", width: "1.5rem" }}
                     />
                  </button>

                  <CustomToggleSwitch
                     checked={row?.is_active === "1"}
                     onChange={() => handleActiveInactive(row)}
                     isLoading={isActiveLoading.id === row?.id && isActiveLoading.status}
                  />
               </div>
            );
         },
      },
   ];

   const handleFilter = (e) => {
      const searchText = e.target.value.toLowerCase();
      const newData = driverMasterList?.filter((item) => {
         return (
            item.name.toLowerCase().includes(searchText) ||
            item.driver_license.toLowerCase().includes(searchText) ||
            item.license_expiry_date.toLowerCase().includes(searchText) ||
            item.payroll.toLowerCase().includes(searchText)
         );
      });
      setRecords(newData);
   };
   return (
      <div>
         <BodyHeader title="Driver Master List" />
         <div className="px-3">
            <div className=" d-flex justify-content-between">
               <CustomInput
                  inputType="text"
                  placeholder="Search..."
                  id="search"
                  onChange={(e) => handleFilter(e)}
               />

               <Stack direction="row" alignItems="center" gap={1}>
                  <DownloadSalaryReport />

                  <DownloadReportButton
                     onDownloadReport={handleDownloadReport}
                     confirmPopup={reportPopup}
                  />
               </Stack>
            </div>
            <CustomTable columns={columns} data={records} />
         </div>
      </div>
   );
}
